import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { checkIsLoggedIn } from '../store/slices/user';

const useInsuranceEnabled = () => {
  const { travelAgency } = useSelector((store) => store.user);
  const isLoggedIn = useSelector(checkIsLoggedIn);
  const { test } = useRouter().query;
  const insurance = travelAgency?.insurance;

  if (!isLoggedIn) return !!insurance?.isEnabledForCFP;
  return test === 'true' ? !!insurance?.isEnabledForTest : !!insurance?.isEnabled;
};

export default useInsuranceEnabled;
